var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgCarrinho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7292 23111)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 40,
    transform: "translate(7292 -23111)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7299.162 -23102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.521,31.4H26.96A2.019,2.019,0,0,1,28.9,33.974l-2.461,8.613-.06.084c-.214.3-.98,1.282-1.853,1.282H9.912ZM25.346,42.053l2.4-8.409A.819.819,0,0,0,26.96,32.6H8.971l1.934,10.152H24.528A2,2,0,0,0,25.346,42.053Z",
    transform: "translate(0 -30.581)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.576,18.448A2.129,2.129,0,1,0,86.7,20.576,2.129,2.129,0,0,0,84.576,18.448Zm-12.771,0a2.129,2.129,0,1,0,2.129,2.129A2.129,2.129,0,0,0,71.8,18.448ZM85.64,14.9H71.976L69.3.865A1.064,1.064,0,0,0,68.257,0L64.064-1a1.064,1.064,0,0,0,0,2.129l3.312,1L70.05,16.163a1.064,1.064,0,0,0,1.045.865H85.64a1.064,1.064,0,0,0,0-2.129Z",
    transform: "translate(-61.162)",
    fill: "#73a91b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCarrinho);
export default __webpack_public_path__ + "static/media/svg-carrinho.a503889bd58c99b7c15357a78986963b.svg";
export { ForwardRef as ReactComponent };